import Constants from 'expo-constants';
import { gql } from '@apollo/client';
import { Linking, Platform } from 'react-native';
import {
  UniversalLink_GetAppLinkQuery,
  UniversalLink_GetAppLinkQueryVariables,
} from '@/types';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';

export const GET_APP_URL_QUERY = gql`
  query UniversalLink_GetAppLink {
    getUniversalAppLink {
      url
    }
  }
`;

export const useUniversalAppLink = () => {
  const { data, hasResponse, loading } = useWrappedQuery<
    UniversalLink_GetAppLinkQuery,
    UniversalLink_GetAppLinkQueryVariables
  >(GET_APP_URL_QUERY, {
    context: {
      anonymous: true,
      noBatch: true,
    },
  });

  const onPressLink = () => {
    if (data?.getUniversalAppLink.url) {
      Linking.openURL(data.getUniversalAppLink.url);
    } else if (Platform.OS === 'ios') {
      Linking.openURL('itms-apps://itunes.apple.com/');
    } else {
      const androidPackage = Constants.expoConfig!.android?.package;
      if (androidPackage) {
        Linking.openURL(`market://details?id=${androidPackage}`);
      } else {
        Linking.openURL('market://');
      }
    }
  };

  return {
    hasResponse,
    loading,
    onPressLink,
  };
};
